import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-text-mark-list',
  templateUrl: './text-mark-list.component.html',
  styleUrls: ['./text-mark-list.component.css']
})
export class TextMarkListComponent implements OnInit {
  @Input() selectIndex = 1;
  // 选中图片后：抛出事件
  @Output() textMarkListChange = new EventEmitter();
  // 选中tab
  tabIndex = 0;
  selectConceptId = '';
  selectRelation = '';
  selectNodeId= '';
  selectRelationId= '';
  instances:any = [];
  instanceRelations:any = [];
  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes){
    if(this.selectIndex == 1){
      this.tabIndex = 0;
    }
    if(this.selectIndex == 2){
      this.tabIndex = 1;
    }
  }

  // 概念筛选
  filterByConcept(){
    if(this.selectConceptId){
      return this.instances.filter(e => e.conceptId == this.selectConceptId);
    }else{
      return this.instances;
    }
  }

  // 关系筛选
  filterByRelation(){
    if(this.selectRelation){
      return this.instanceRelations.filter(e => e.relationName == this.selectRelation);
    }else{
      return this.instanceRelations;
    }
  }

  // 选中概念
  clickSelectConcept(item){
    if(this.selectConceptId !== item.conceptId){
      this.selectNodeId = '';
    }
    this.selectConceptId = this.selectConceptId == item.conceptId ? '' : item.conceptId;
    if(!this.selectConceptId){
      this.selectNodeId = '';
    }
    this.emitData();
  }

  // 选中关系
  clickSelectRelation(item){
    if(this.selectRelation !== item.relationName){
      this.selectRelationId = '';
    }
    this.selectRelation = this.selectRelation == item.relationName ? '' : item.relationName;
    if(!this.selectRelation){
      this.selectRelationId = '';
    }
    this.emitData();
  }

  // 定位到指定实体所在行
  toPositionByEntity(d,i){
    this.selectNodeId = d.instances[i].uuid;
    this.emitData();
  }


  // 定位到指定关系所在行
  toPositionByRelation(d,i){
    this.selectRelationId = d.relations[i].uuid;
    this.emitData();
  }
  
  // 截取字符串的前n个字符，并在末尾添加省略号
  textSlice(str,n){
    if(str.length < n){
      return str;
    }else{
      return str.slice(0,n)+'...';
    }
  }

  // 切换分类、选择概念、指定实体、关系类别、指定关系后，向父组件发射数据，设置显示或隐藏实体、连线
  emitData(){
    if(this.tabIndex == 0){
      this.textMarkListChange.emit({
        type: this.tabIndex,
        conceptId: this.selectConceptId,
        instanceId: this.selectNodeId
      });
    }else{
      this.textMarkListChange.emit({
        type: this.tabIndex,
        relationName: this.selectRelation,
        relationId: this.selectRelationId
      });
    }
  }
}
